import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-styled-html',
    templateUrl: './styled-html.component.html',
    styleUrls: ['./styled-html.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class StyledHtmlComponent {
    @Input({ required: true }) html!: string;
}
